



























import { defineComponent } from "@vue/composition-api"
import { joinTexts } from "@/app/filters/join-texts.filter"
import ParkTime from "@/app/components/booking/ParkTime.vue"
import ParkPrice from "@/app/components/booking/ParkPrice.vue"
import { FacilityModel } from "@/app/models/facility.model"
import { PromocodeModel } from "@/app/models/promocode.model"
import TranslatableDetails from "../common/TranslatableDetails.vue"
import {BookingModel} from "@/app/models/booking.model";

export default defineComponent({
  components: { ParkTime, ParkPrice, TranslatableDetails },
  props: {
    booking: {
      type: Object as () => BookingModel,
      required: true,
    },
    hint: Array,
    facility: {
      type: Object as () => FacilityModel,
      required: true,
    },
    promocode: {
      type: Object as () => PromocodeModel,
      required: false,
    },
  },
  setup() {
    return { joinTexts }
  },
})
